import { useCallback, useEffect, useRef, useState } from 'react';

export const useLastKeyboardInteraction = () => {
  const lastKeyboardInteractionRef = useRef(false);
  const [focusByKeyboard, setFocusByKeyboard] = useState(false);

  useEffect(() => {
    const handleKeyDown = () => {
      lastKeyboardInteractionRef.current = true;
    };

    const handleMouseDown = () => {
      lastKeyboardInteractionRef.current = false;
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('mousedown', handleMouseDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  const onFocus = useCallback(() => {
    setFocusByKeyboard(lastKeyboardInteractionRef.current);
    lastKeyboardInteractionRef.current = false;
  }, []);

  const onBlur = useCallback(() => {
    lastKeyboardInteractionRef.current = false;
  }, []);

  return { focusByKeyboard, onFocus, onBlur };
};
